<template>
  <div class="chart-section">
    <div class="chart-title">برآیند کلی دارایی شما</div>
    <div id="chart-line2">
      <apex-chart type="area"  height="430" :options="chartOptions" :series="series"></apex-chart>
    </div>
    <div class="chart-line" id="chart-line">
      <apex-chart type="line"  height="35"  :options="chartOptionsLine" :series="seriesLine"></apex-chart>
    </div>
  </div>
</template>

<script>
export default {
  name: "TotalDepsoitChart.vue",
  data(){
    return{
      series: [{
        data: [ {
          x: new Date('2017-02-5').getTime(),
          y: 36
        }, {
          x: new Date('2017-03-6').getTime(),
          y: 26
        }, {
          x: new Date('2017-04-7').getTime(),
          y: 76
        }, {
          x: new Date('2017-05-12').getTime(),
          y: 16
        },{
          x: new Date('2017-07-6').getTime(),
          y: 26
        }, {
          x: new Date('2017-08-7').getTime(),
          y: 76
        }, {
          x: new Date('2017-09-12').getTime(),
          y: 16
        },{
          x: new Date('2018-03-12').getTime(),
          y: 96
        }, {
          x: new Date('2018-05-12').getTime(),
          y: 6
        }, {
          x: new Date('2018-08-12').getTime(),
          y: 70
        }, {
          x: new Date('2018-09-12').getTime(),
          y: 218
        },
        ]

      }],
      chartOptions: {
        chart: {
          id: 'chart2',
          width:'100%',
          type: 'line',
          toolbar: {
            autoSelected: 'pan',
            show: false
          },

        },
        grid: {
          show: true,
          borderColor: '#90A4AE',
          strokeDashArray:2,

        },
        // type: 'gradient',
        // // gradient: {
        // //   shadeIntensity: 1,
        // //   opacityFrom: 0.7,
        // //   opacityTo: 0.9,
        // //   stops: [0, 100]},
        fill: {
          colors: ['#04B3A2'],
          type: 'gradient',
          gradient: {
            opacityFrom: 0.54,
            opacityTo: 0.4,
            stops: [0, 100]
          }
        },
        colors: ['#04B3A2'],
        stroke: {
          width: 2,
          curve: 'straight',
        },
        dataLabels: {
          enabled: false
        },

        markers: {
          size: 0
        },
        xaxis: {
          type: 'datetime',
          labels: {
            style: {
              colors: ['rgba(255, 255, 255, 0.6)','rgba(255, 255, 255, 0.6)','rgba(255, 255, 255, 0.6)',
                'rgba(255, 255, 255, 0.6)','rgba(255, 255, 255, 0.6)','rgba(255, 255, 255, 0.6)',
                'rgba(255, 255, 255, 0.6)','rgba(255, 255, 255, 0.6)','rgba(255, 255, 255, 0.6)',],
            }
          }
        } ,
        yaxis: {
          labels: {
            style: {
              colors: ['rgba(255, 255, 255, 0.6)','rgba(255, 255, 255, 0.6)','rgba(255, 255, 255, 0.6)',
                'rgba(255, 255, 255, 0.6)','rgba(255, 255, 255, 0.6)','rgba(255, 255, 255, 0.6)',
                'rgba(255, 255, 255, 0.6)','rgba(255, 255, 255, 0.6)','rgba(255, 255, 255, 0.6)',],
            }
          }
        }
      },

      seriesLine: [{
        data: [
          {
            x: new Date('2017-02-5').getTime(),
            y: 36
          }, {
            x: new Date('2017-03-6').getTime(),
            y: 26
          }, {
            x: new Date('2017-04-7').getTime(),
            y: 76
          }, {
            x: new Date('2017-05-12').getTime(),
            y: 16
          },{
            x: new Date('2017-07-6').getTime(),
            y: 26
          }, {
            x: new Date('2017-08-7').getTime(),
            y: 76
          }, {
            x: new Date('2017-09-12').getTime(),
            y: 16
          },{
            x: new Date('2018-03-12').getTime(),
            y: 96
          }, {
            x: new Date('2018-05-12').getTime(),
            y: 6
          }, {
            x: new Date('2018-08-12').getTime(),
            y: 70
          }, {
            x: new Date('2018-09-12').getTime(),
            y: 218
          },
        ]

      }],
      chartOptionsLine: {
        chart: {
          background: 'rgba(255, 255, 255, 0.04)',
          id: 'chart1',
          width:'100%',

          height: 130,
          type: 'line',
          sparkline: {
            enabled: true,
          },
          brush:{
            target: 'chart2',
            enabled: true,
            autoScaleYaxis: false
          },
          selection: {
            enabled: true,
            fill: {
              color: "#04B3A2",
              opacity: 0.1
            },
            stroke: {
              width: 2,
              dashArray: 0,
              color: '#04B3A2',
              opacity: 1
            },
            xaxis: {
              min: new Date('2017-02-12').getTime(),
              max: new Date('2017-05-12').getTime()
            }
          },
        },
        colors: ['rgba(255, 255, 255, 0.4)'],


        xaxis: {
          type: 'datetime',
          tooltip: {
            enabled: false
          }
        },
        yaxis: {
          tickAmount: 2
        }
      },

    }
  }
}
</script>

<style scoped>
.chart-line{
  padding: 0px 0px 0px 20px;
}
.chart-section{

  padding: 20px 20px 20px 0px;
  background: linear-gradient(180deg, #091222 0%, #0A1425 100%);
  box-shadow: 0px 4px 24px -1px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  /*flex-basis: 250px;*/
  flex-grow: 1;
  /*width: 100%;*/
  /*max-width: 600px;*/
}

.chart-title{
  color: #FFFFFF;
  font-size: clamp(14px,1.5vw,16px);
  text-align: right;
}

/*::v-deep .sortable-handler {*/
/*  touch-action: none;*/
/*}*/
@media (max-width: 500px) {
  .chart-section{
    width: 80%;
  }
}
</style>